import { FC, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";

import { BandRegionalSettingsForm } from "Bands/components";
import { clearActionMeta, editBand } from "Bands/state";
import { dataMetaSelector } from "Bands/state";
import { BAND_ACTIONS, IBand } from "Bands/types";
import { useBandContext } from "Bands/contexts";
import { BAND_PATHS } from "Bands/router";

import { copy } from "shared/assets";
import { Card } from "shared/components";
import { IAPIState, IStatus } from "shared/types";
import { addTemporaryToast } from "shared/components/Toast";
import { Globe } from "shared/assets/icons";
import { useBandRoute } from "Bands/utils";

const {
  bandSettings: { regionalSettings, messages },
} = copy;

export const EditRegionalSettings: FC = () => {
  const dispatch = useDispatch();
  const { bandId, band } = useBandContext();
  const defaultValues = useMemo(
    () => ({
      timeZone: band?.timeZone,
      dateFormat: band?.dateFormat,
      timeFormat: band?.timeFormat,
    }),
    [band]
  );
  const { pushRoute } = useBandRoute();

  const { api: apiMeta } = useSelector(dataMetaSelector(BAND_ACTIONS.editBand));

  const handleSubmit = (data: Partial<IBand>) => {
    if (!bandId) return;

    dispatch(editBand({ bandId, bandData: data }));
  };

  useEffect(() => {
    if (apiMeta?.status === IAPIState.succeeded && bandId) {
      pushRoute(BAND_PATHS.BAND_SETTINGS);

      dispatch(
        addTemporaryToast({
          status: IStatus.success,
          message: messages.regionalSettingsSuccess,
        })
      );

      dispatch(clearActionMeta(BAND_ACTIONS.editBand));
    }
  }, [bandId, apiMeta, pushRoute, dispatch]);

  return (
    <Card title={regionalSettings.title} icon={Globe}>
      <BandRegionalSettingsForm
        defaultValues={defaultValues}
        handleSubmit={handleSubmit}
        isSubmitting={apiMeta?.status === IAPIState.pending}
        hasError={!!apiMeta?.error}
        apiError={apiMeta?.error}
      />
    </Card>
  );
};
